/* eslint-disable prefer-arrow/prefer-arrow-functions */

import React, { useEffect, useState } from 'react';
import axios from 'axios';

function ListUsersB2b() {
  const [users, setUsers] = useState([]);
  // const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
  useEffect(() => {
    axios
      .get(`/api/b2b/all`)
      .then((res) => setUsers(res.data))
      .catch((err) => console.error(err));
  }, []);

  const validerCompte = async (id) => {
    if (!window.confirm('Valider ce compte ?')) return;

    try {
      await axios.patch(`/api/b2b/validate/${id}`);
      alert('Compte validé et mail envoyé.');
      setUsers(users.map((u) => (u._id === id ? { ...u, status: 'valid' } : u)));
    } catch (err) {
      console.error('Erreur validation:', err);
      alert('Erreur validation.');
    }
  };

  const supprimerCompte = async (id) => {
    if (!window.confirm('Supprimer cet utilisateur ?')) return;

    try {
      await axios.delete(`/api/b2b/delete/${id}`);
      setUsers(users.filter((u) => u._id !== id));
      alert('Utilisateur supprimé.');
    } catch (err) {
      console.error('Erreur suppression :', err);
      alert('Erreur lors de la suppression.');
    }
  };

  return (
    <div className="container mt-4">
      {users.length === 0 ? (
        <p>Aucun utilisateur trouvé.</p>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Entreprise</th>
              <th>Email</th>
              <th>SIRET</th>
              <th>Téléphone</th>
              <th>Adresse</th>
              <th>Statut</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u._id}>
                <td>{u.companyName}</td>
                <td>{u.email}</td>
                <td>{u.siret}</td>
                <td>{u.phone}</td>
                <td>{u.adresse}</td>
                <td>
                  <span
                    className={`badge ${u.status === 'valid' ? 'bg-success' : 'bg-warning'}`}
                  >
                    {u.status}
                  </span>
                </td>

                <td>
                  {u.status === 'pending' ? (
                    <>
                      <button
                        onClick={() => validerCompte(u._id)}
                        className="btn btn-success"
                        style={{ padding: '0px', fontSize: 10 }}
                      >
                        Valider
                      </button>
                      <button
                        onClick={() => supprimerCompte(u._id)}
                        className="btn btn-danger"
                        style={{ marginLeft: '10px', padding: '0px', fontSize: 10 }}
                      >
                        🗑️ Supprimer
                      </button>
                    </>
                  ) : (
                    <span>✔️ Validé</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ListUsersB2b;
